import type { MutableRefObject } from 'react';
import FieldRenderer from './FieldRenderer';
import { FormRendererProvider } from './FormRendererContext';
import type { FieldSchema } from './types';

interface FormRendererProps {
  fields: FieldSchema[];
  mapRef: MutableRefObject<any>;
  isLoadingSensorData: boolean;
}

const FormRenderer = ({ fields, mapRef, isLoadingSensorData }: FormRendererProps) => (
  <FormRendererProvider value={{ mapRef, isLoadingSensorData }}>
    {fields?.map((field) => <FieldRenderer key={field.name || field.label} field={field} />)}
  </FormRendererProvider>
);

export default FormRenderer;
